// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1rs2S","amount":"Amount_amount__1IHot","tip":"Amount_tip__1HfOE","tipHeader":"Amount_tipHeader__1naBU","tipsWrap":"Amount_tipsWrap__2iUSy"};